import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../shared/Navbar.css'; // O la ruta exacta donde esté tu CSS original

function AdminNavbar() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setMenuAbierto(false);
    navigate('/login-admin'); // Redirigimos al login de admin específicamente
  };

  return (
    <nav className="navbar navbar-admin"> {/* Clase extra por si quieres estilos rojos/admin */}
      <h2 className="navbar-logo">Clavelina Admin</h2>

      <div className="hamburguesa" onClick={() => setMenuAbierto(!menuAbierto)}>
        ☰
      </div>

      <ul className={`navbar-links ${menuAbierto ? 'activo' : ''}`}>
        <li onClick={() => { navigate('/admin'); setMenuAbierto(false); }}>Gestión</li>
        <li onClick={() => { navigate('/admin/completados'); setMenuAbierto(false); }}>Historial</li>
        
        <li className="user-name">Admin: <strong>{user?.nombre}</strong></li>
        
        <li onClick={handleLogout} className="logout-btn">Cerrar Sesión</li>
      </ul>
    </nav>
  );
}

export default AdminNavbar;